import { render, staticRenderFns } from "./FlagDisplay.vue?vue&type=template&id=1b6489c5&scoped=true&"
import script from "./FlagDisplay.vue?vue&type=script&lang=js&"
export * from "./FlagDisplay.vue?vue&type=script&lang=js&"
import style0 from "./FlagDisplay.vue?vue&type=style&index=0&id=1b6489c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6489c5",
  null
  
)

export default component.exports